export default {"src":"/_next/static/media/visa.5d4c8046.svg","height":10,"width":28,"blurWidth":0,"blurHeight":0};